import type { MetaFunction } from "react-router";
import { SITE_NAME } from "@/lib/constants";
import Privacy from "@/pages/Privacy";

export const meta: MetaFunction = () => [
  { title: `Privacy Policy | ${SITE_NAME}` },
  {
    name: "description",
    content: "LoadLogo privacy policy. How we collect, use, and protect your data.",
  },
  { property: "og:title", content: `Privacy Policy | ${SITE_NAME}` },
  {
    property: "og:description",
    content: "LoadLogo privacy policy. How we collect, use, and protect your data.",
  },
  { property: "og:type", content: "website" },
  { property: "og:url", content: "https://loadlogo.com/privacy" },
  { property: "og:site_name", content: SITE_NAME },
  { name: "twitter:card", content: "summary_large_image" },
];

export default function PrivacyRoute() {
  return <Privacy />;
}
